import { render, staticRenderFns } from "./coPrice.vue?vue&type=template&id=5a2b75a8&scoped=true&"
import script from "./coPrice.vue?vue&type=script&lang=ts&"
export * from "./coPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b75a8",
  null
  
)

export default component.exports